"use client";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { MagnifierIcon, WalletIcon, ChartIcon } from "./Icons";
import { useTranslation } from "@/hooks/useLanguage";

const serviceIcons = [<MagnifierIcon key="magnifier" />, <WalletIcon key="wallet" />, <ChartIcon key="chart" />];

export const Services = () => {
  const { t } = useTranslation();
  const services = t("services.services_list");

  // Ensure services is always an array to prevent runtime errors
  const safeServices = Array.isArray(services) ? services : [];

  return (
    <section className="container py-24 sm:py-32">
      <div className="grid lg:grid-cols-[1fr,1fr] gap-8 place-items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold">
            <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
              {t("common.pms")}{" "}
            </span>
            {t("common.services")}
          </h2>

          <p className="text-muted-foreground text-xl mt-4 mb-8">
            {t("services.description")}
          </p>

          <div className="flex flex-col gap-8">
            {safeServices.map(({ title, description }, index) => (
              <Card key={title}>
                <CardHeader className="space-y-1 flex md:flex-row justify-start items-start gap-4">
                  <div className="mt-1 bg-primary/20 p-1 rounded-2xl">
                    {serviceIcons[index]}
                  </div>
                  <div>
                    <CardTitle>{title}</CardTitle>
                    <CardDescription className="text-md mt-2">
                      {description}
                    </CardDescription>
                  </div>
                </CardHeader>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
